import {OPEN_DRAW_CONTROL_POPUP, CLOSE_DRAW_CONTROL_POPUP} from "../constants/action-types";

export default (state = '', action) => {
    const {type, payload} = action

    switch (type) {
        case OPEN_DRAW_CONTROL_POPUP:
            return payload
        case CLOSE_DRAW_CONTROL_POPUP:
            return ''
    }

    return state
}